/*
 * Home contact
 * Used in another component.
 */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'environments/environment';
import * as L from 'leaflet';

import { LatLng, tileLayer } from 'leaflet';
@Component({
  selector: '[angly-homeContact]',
  templateUrl: './homeContact.component.html',
  styleUrls: ['./homeContact.component.scss']
})



export class HomeContactComponent implements OnInit {

   mapBoxToken: string = environment.mapBoxToken;
   defaultMapCenter: LatLng = new LatLng(40.531018135031296, 17.434091644128326);
   @Input() contact : any;
   lat: number = 40.53101481011528;
	lng: number = 17.43408576839406;
   map!: L.Map;
   constructor() { }

   ngOnInit() {
   }
   /*options = {
      layers: [
        tileLayer("https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=" + this.mapBoxToken, {
          id: "mapbox/light-v9",
          tileSize: 512,
          zoomOffset: -1,
          attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        })
      ],
      zoom: 15.1,
      center: this.defaultMapCenter
    };*/

    options = {
      layers: [
         tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '...' })
      ],
      zoom: 13,
      center: this.defaultMapCenter
   };


      // get the reference to the map
  onMapReady(map: L.Map) {
   this.map = map;
 }
}
